<div class="full-modal-breadcrumbs">
    <div class="full-modal-breadcrumbs__breadcrumbs-container">
        <ng-container *ngFor="let breadcrumb of breadcrumbStack; last as isLast; trackBy: trackByIndex">
            <full-modal-breadcrumb
                [isActive]="isLast"
                [name]="(breadcrumb.breadcrumbName$ | async) || breadcrumb.getName?.()"
                [description]="(breadcrumb.breadcrumbDescription$ | async) || breadcrumb.getDescription?.()"
                class="full-modal-breadcrumbs__breadcrumb"
            ></full-modal-breadcrumb>
        </ng-container>
    </div>
    <div class="full-modal-breadcrumbs__footer"></div>
</div>
